module.exports = __webpack_public_path__ + "img/ilya.43af90c3.png";